import cn from 'classnames';

import { setJumpLinkAttributes } from 'src/utils/jumpLinks';

import LocationCard from 'components/BaseHelpers/LocationCard';
import StartIndex from 'components/BaseHelpers/StartIndex';
import StopIndex from 'components/BaseHelpers/StopIndex';
import Text from 'components/BaseHelpers/Text';

import { ComponentProps } from '../../../types/component-props';
import { CoreLocationsListingGroupsData } from '../../../types/components';

import styles from './CoreLocationsListingGroups.module.scss';

export type CoreLocationsListingGroupsProps = ComponentProps & CoreLocationsListingGroupsData;

const CoreLocationsListingGroups = (props: CoreLocationsListingGroupsProps): JSX.Element => {
  const { groups } = props.fields;

  const filteredGroups = groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => item.name && (item.link.href || item.link.url)),
    }))
    .filter((group) => group.items.length > 0);

  if (filteredGroups.length === 0) {
    return <></>;
  }

  return (
    <>
      <StopIndex />
      <div className={cn(styles.main, 'container-10')}>
        {filteredGroups.map((group, index) => (
          <div key={index} className={styles.group} {...setJumpLinkAttributes(group.title)}>
            <Text tag="h2" field={group.title} className={cn('heading-h3')} />
            <ul className={styles.items}>
              {group.items.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <LocationCard {...item} className={styles.card} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <StartIndex />
    </>
  );
};

export default CoreLocationsListingGroups;
